'use strict';

angular.module('isahomeApp')
    .controller('LoginController', function ($rootScope, $scope, $state, $timeout, Auth, $uibModalInstance, $window) {
        $scope.authenticationError = false;

        $scope.rememberMe = true;
        $timeout(function (){angular.element('[ng-model="username"]').focus();});
        $scope.login = function (event) {
            event.preventDefault();
            Auth.login({
                username: $scope.username,
                password: $scope.password,
                rememberMe: $scope.rememberMe
            }).then(function () {
                $scope.authenticationError = false;
                $uibModalInstance.close();
                // If we're redirected to login, our
                // previousState is already set in the authExpiredInterceptor. When login succesful go to stored state
                if ($rootScope.redirected && $rootScope.previousStateName) {
                    $state.go($rootScope.previousStateName, $rootScope.previousStateParams, {reload:true});
                    $rootScope.redirected = false;
                } else {
                    $rootScope.$broadcast('authenticationSuccess');
                    if($state.current.name === 'page'){
                        $window.location.reload();
                        return;
                    } else if ($state.current.name === 'finishReset') {
                        $state.go('home');
                        return;
                    }
                    $state.go($state.current.name, {}, {reload:true})
                }
            }).catch(function () {
                $scope.authenticationError = true;
            });
        };

        $scope.cancel = function () {
            $scope.credentials = {
                username: null,
                password: null,
                rememberMe: true
            };
            $scope.authenticationError = false;
            $uibModalInstance.dismiss('cancel');
        };

        $scope.requestResetPassword = function () {
            $uibModalInstance.dismiss('cancel');
            $state.go('requestReset');
        };

        $scope.register = function () {
            $uibModalInstance.dismiss('cancel');
            $state.go('register');
        };
        $scope.contactUs = function () {
            $uibModalInstance.dismiss('cancel');
            $state.go('page', {name: 'contact-us'});
        };
    });
